import React from 'react';

const LinkButton = ({ children, onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`text-[#0C1D40] underline hover:text-[#1A2B50] transition text-sm font-medium ${className}`}
    >
      {children}
    </button>
  );
};

export default LinkButton;